import axios from 'axios';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { SettingsContext } from '../store/SettingsContext';

const useSextforcePulicMetricLiveStats = (metricShareLinkId: string, metricId: string | undefined | null) => {
    const settingsContext = useContext(SettingsContext);

    // Retrieve subscriber data
    const fetchMetric = async (): Promise<{
        counters: {
            countSubscribers?: number;
            countTransitions?: number;
            claimsCount?: number;
            subscribeCounts?: number;
        };
        updatedAt: Date;
    }> => {
        const query: string = `${settingsContext.routes.sextforce.publicMetrics}${metricShareLinkId}/liveStatsSingle/${metricId}`;

        return axios
            .get(query, {
                method: 'get',
                headers: {
                    apiKey: settingsContext.apiKey,
                },
            })
            .then(response => response.data);
    };

    return useQuery(['publicMetricListStats', metricShareLinkId, metricId], () => fetchMetric(), {
        refetchOnWindowFocus: true,
        staleTime: 0,
        enabled: metricShareLinkId && metricId ? true : false,
        // 1 minute
        refetchInterval: 60000,
        retry: 0,
        keepPreviousData: true,
    });
};

export default useSextforcePulicMetricLiveStats;
